import * as React from 'react';

import { getLocale } from '@rematter/common/locale';
import { enumUnit } from '@rematter/frontend-lib-api-client';
import { useTranslations } from '@rematter/modules/brokerage/i18n/useTranslations';
import { FooterItem, MeasuredValue, Money } from '@rematter/ui-web';

import { QuoteLineItemData } from './types';

import { useQuoteLineItemsTotals } from '~/modules/brokerage/hooks/useQuoteLineItemsTotals';

type Props = {
  lineItems: QuoteLineItemData[];
};

export const QuoteLineItemsSummaryFooter: React.FC<Props> = ({ lineItems }) => {
  const t = useTranslations();

  const { totalWeight, totalEachCount, estimatedTotal } =
    useQuoteLineItemsTotals(lineItems);

  const hasWeight = totalWeight !== null && (totalWeight?.value ?? 0) > 0;
  const hasEachCount = totalEachCount > 0;

  return (
    <>
      <FooterItem label={t.quotes.lineItems.totals.material}>
        <span className="text-lg font-bold tracking-tight">
          {lineItems.length}
        </span>
      </FooterItem>

      <div className="h-9 w-px bg-neutral/10" />

      <FooterItem label={t.quotes.lineItems.totals.totalWeight}>
        <div className="flex items-baseline gap-3 text-lg font-semibold">
          {hasWeight && (
            <div className="text-lg font-bold">
              <MeasuredValue
                value={totalWeight.value}
                unit={totalWeight.unit}
              />
            </div>
          )}
          {hasEachCount && (
            <div className="text-lg font-bold">
              <MeasuredValue value={totalEachCount} unit={enumUnit.Each} />
            </div>
          )}
          {!hasWeight && !hasEachCount && <div>0</div>}
        </div>
      </FooterItem>

      <div className="h-9 w-px bg-neutral/10" />

      <FooterItem label={t.quotes.lineItems.totals.estimatedTotal}>
        <div className="text-lg font-semibold">
          <Money {...estimatedTotal} locale={getLocale()} />
        </div>
      </FooterItem>
    </>
  );
};
